import fromObjectToValues from 'utils/converters/object/fromObjectToValues.util';

// NOTE: result from beSCustomPermissions

// just a helper to reduce noise
const p = (index, snake, camel) => Object.freeze({ index, snake, camel });

const PERM = {
  //
  // NOTE: avoid using these, they are for testing only

  test: Object.freeze({ index: -2, snake: 'test_test:test', camel: 'test' }),
  none: Object.freeze({ index: -1, snake: 'none_none:none', camel: 'none' }),

  //
  // NOTE: the actual BE related permissions start here

  canViewDailyCashupPersonal: p(5, 'can_view_daily_cashup:personal', 'canViewDailyCashupPersonal'),
  canViewDailyCashupAllStaff: p(6, 'can_view_daily_cashup:all_staff', 'canViewDailyCashupAllStaff'),

  canViewKpiReportsPersonal: p(8, 'can_view_kpi_reports:personal', 'canViewKpiReportsPersonal'),
  canViewKpiReportsAllStaff: p(9, 'can_view_kpi_reports:all_staff', 'canViewKpiReportsAllStaff'),

  canEditStaffPermissions: p(10, 'can_edit_staff_permissions:true', 'canEditStaffPermissions'),

  canEditStaffCommissions: p(15, 'can_edit_staff_commissions:true', 'canEditStaffCommissions'),

  canEditKpisPersonal: p(13, 'can_edit_kpis:personal', 'canEditKpisPersonal'),
  canEditKpisAllStaff: p(14, 'can_edit_kpis:all_staff', 'canEditKpisAllStaff'),
};

for (const perm of fromObjectToValues(PERM)) {
  PERM[perm.index] = perm;
  PERM[perm.camel] = perm;
  PERM[perm.snake] = perm;
}

// OK, we no longer allow adding permissions to this object
Object.freeze(PERM);

export default PERM;
